<template>
    <va-show-layout>
        <va-show :item="item">
            <v-row justify="center">
                <v-col sm="6">
                    <base-material-card>
                        <template v-slot:heading>
                            <div class="display-2">
                                {{ title }}
                            </div>
                        </template>
                        <v-card-text>
                            <va-field source="name"></va-field>
                            <va-field source="client_id"></va-field>
                            <va-field source="region"></va-field>
                            <va-field source="is_activated"></va-field>
                            <va-field source="sandbox"></va-field>
                            <va-field source="created_at"></va-field>
                            <va-field source="updated_at"></va-field>
                        </v-card-text>
                    </base-material-card>
                </v-col>
            </v-row>
        </va-show>
    </va-show-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
